const categories = ["APPETIZERS", "MAINCOURSE", "BIRYANI", "DESSERTS", "BEVERAGES", "COLDBEVERAGES"];


export default categories